import { RxService } from "./../../../services/rx.service";
import {
    Component,
    OnInit,
    Output,
    EventEmitter,
    ViewChild,
    ElementRef,
    ChangeDetectorRef,
    AfterViewInit,
    OnDestroy,
    HostListener
} from "@angular/core";
import * as _ from "lodash";
import { CollectionView } from "@grapecity/wijmo";
import * as moment from "moment";
import { AlertService, CommonService, ModalWrapperService, PatPreDrugModalService, QuickRefillService } from "src/app/services";
import { Router } from "@angular/router";
import { RxDateInputParams } from "../../../models";
import * as wjcCore from "@grapecity/wijmo";
import { ColorCode, CommonUtil, WijimoUtil } from "src/app/utils";
import * as wjcGrid from "@grapecity/wijmo.grid"
import { HoverOver } from "src/app/utils/hover-over.util";
import { takeUntil } from "rxjs/operators";
import { Subject } from "rxjs";
import { ColorCodeRx } from "src/app/utils/rx-color.util";
import { StorageService } from "src/app/services/storage.service";
import { FormatsUtil } from "src/app/utils/formats.util";

@Component({
    selector: "app-refill-queue-add",
    templateUrl: "./refill-queue-add.component.html",
    standalone: false
})
export class RefillQueueAddComponent implements OnInit, AfterViewInit, OnDestroy {
    @Output()
    IsPopUpClosed = new EventEmitter<null>();

    @ViewChild("AddQueue", { static: true })
    AddQueue: any;

    @ViewChild("searchRx")
    searchRx: ElementRef;

    @ViewChild("Rxexists", { static: true })
    Rxexists: any;

    @ViewChild("deceasedRx", { static: true })
    deceasedRx: any;

    @ViewChild("duplicateRx", { static: true})
    duplicateRx: any
    @ViewChild('rxSearchInput') rxSearchInput: any;

    @Output()
    ClosePopUp = new EventEmitter<any>();

    modalRef: any;
    rxNumber: number;
    refillWJ: CollectionView;
    actvHeaders: any;
    newRxData: any;
    rxData: Array<any> = [];
    rxDataCopy: Array<any> = [];
    slctdRxObj: any = {};
    selectedRxs: any[] = [];
    rxCount: number;
    isSelected = false;
    refType: string;
    rxNum: number;
    initiateRegRefill = false;
    initiateQuickRef = false;
    rxNmbr = null;
    modalRef2: any;
    count = 0;
    prescNumDup = 0;
    warningMsgPat: string = "";
    dateParams: RxDateInputParams;
    modalRef1: any;
    foundRx: any[] = [];
    showRxNos: any[] = [];
    found: any;
    warnDuplicate: string;
    addRefillQueueListDisplayWJ: any;
    wjHeaders: any = [];
    RfOrRx: any;
    prescCountData: any = [];
    prescriptionQuantities: any = [];
    rxInputParams: any = {};
    unsubscribe$: Subject<void> = new Subject();

    @HostListener("window:keydown", ["$event"])
    keyEvent(event: KeyboardEvent) {
        if (event.keyCode === 27) {
            if (this.modalRef) {
                event.preventDefault();
                this.closeModal();
            }
        }
    }

    constructor(
        private _modalService: ModalWrapperService,
        private _alertService: AlertService,
        private _commonSvc: CommonService,
        private _cdr: ChangeDetectorRef,
        private _rxSrvc: RxService,
        private _colorCode: ColorCode,
        private _quickRefilsvc: QuickRefillService,
        private _router: Router,
        private _wijimoUtils: WijimoUtil,
        private _patPreDrugModalServ: PatPreDrugModalService,
        private commonUtil: CommonUtil,
        private _hoverOver: HoverOver,
        private _colorCodeRx: ColorCodeRx,
        public _storageService : StorageService,
        private _formatsUtil : FormatsUtil
    ) {
        this.dateParams = {
            StartDate: null,
            EndDate: null
        };
        this.dateParams.StartDate = moment()
            .subtract(7, "days")
            .format("YYYY-MM-DD");
        this.dateParams.EndDate = moment()
            .subtract(0, "days")
            .format("YYYY-MM-DD");
    }

    ngOnInit() {
        this.rxInputParams = {
            patientId: null,
            prescriberId: null,
            drugId: null,
            prescNum: null,
            refillNum: null,
            remarks: null,
            rxId: null,
            prescRefillId: null
        };
        this.RfOrRx = this._commonSvc.getSetttingValue("PharmacySettings", "ALLOW_REFILL_TRANS_OUT");
        this.modalRef = this._modalService.open(this.AddQueue, {
            size: "lg",
            centered: true,
            backdrop: "static",
            keyboard: false,
            windowClass:"bestDealPrompt_left"
        });
        this.patchDefaultValHeaders();
        this.generateControlFileWJ([]);
    }

    ngAfterViewInit() {
        this._cdr.detectChanges();
    }

    ngOnDestroy() {
        this._storageService.getWijmoGridDataInSession(this.wjHeaders,"refillQueueWJ")
        this._cdr.detach();
        this.unsubscribe$.next();
        this.unsubscribe$.complete();
    }
    async patchDefaultValHeaders() {
        const storedWJ = await this._wijimoUtils.getWJSavedData("refillQueueWJ");
        this.wjHeaders = this._wijimoUtils.patchDefHeader("refillQueueWJ", storedWJ);
    }

    openDeceasedPopup(data) {
        this.warningMsgPat = data ?
            (data.Patient.lastname + ", " + data.Patient.firstname).toUpperCase() : "";
        this.modalRef2 = this._modalService.open(this.deceasedRx, {
            centered: true,
            backdrop: false,
            keyboard: false,
            windowClass:"large--content"
        });
    }

    getRx(rxNo, type?: string) {
        if (document.getElementById("searchRx")) {
            document.getElementById("searchRx").blur();
        }
        this.rxNumber = rxNo;
        if (this.rxNumber) {
            if (this.rxData && this.rxData.length > 0) {
                this.found = this.rxData.find(el => el.Prescription.PrescNum.toString() === this.rxNumber);
                if (this.found) {
                    this.foundRx.push(this.found);
                }
            } else {
                this.found = null;
            }
            if (this.found && type === "fromInput") {
                this.showRxNos.push(this.found.Prescription.PrescNum);
                this.modalRef1 = this._modalService.open(this.Rxexists, {
                    keyboard: false,
                    centered: true,
                    backdrop: false,
                    windowClass:"large--content"
                });
                return;
            } else if (!this.found) {
                this.count += 1;
                this.rxInputParams.prescNum = this.rxNumber.toString();
                this._quickRefilsvc.postRefillData(this.rxInputParams)
                .pipe(takeUntil(this.unsubscribe$))
                .subscribe(resp => {
                        if (resp && resp.length &&  resp[0]["Refdetail"] && resp[0]["Refdetail"] && resp[0]["Refdetail"]["Refilldetails"] &&  resp[0]["Refdetail"]["Refilldetails"].length) {
                            this.newRxData = resp[0]["Refdetail"]["Refilldetails"][0];
                            const resp1 = resp[0]["Refdetail"]["Refilldetails"][0];
                            if (this.newRxData && this.newRxData.Patient && this.newRxData.Patient.isdeceased) {
                                this.openDeceasedPopup(this.newRxData);
                            } else {
                                this.rxData.push({
                                    ...resp1,
                                    ...{ IsSelected: true }
                                });
                                this.rxDataCopy.push({
                                    ...resp[0],
                                    ...{ IsSelected: true }
                                });
                                this.generateAddRefillQueueWJ(this.rxDataCopy);
                                this.selectedRxs.push({
                                    Prescnum: resp1.Prescription["PrescNum"],
                                    PrescrefillId: resp1.PrescReFill["Id"],
                                    PartialFillNo:    resp1["PrescReFill"]["PartialFillNo"],
                                    ReFillNum:   resp1["PrescReFill"]["ReFillNum"]
                                });
                                this.clearValueAndFocus();
                            }
                        } else if (
                            resp === null ||
                            resp.length === 0 ||
                            resp[0] === null
                        ) {
                            this._alertService.error("Rx not found.");
                            this.clearValueAndFocus();
                        }
                        this.rxNumber = null;
                    });
            }
        }
    }

    clearValueAndFocus(type?: string) {
        if (this.modalRef1 && type === "Rxexists") {
            this.modalRef1.close();
            this.found = null;
            this.foundRx = [];
            this.showRxNos = [];
            this.count = 0;
        }
        if (!(this.foundRx && this.foundRx.length > 0)) {
            const ele = document.getElementById("searchRx");
            if (ele) {
                document.getElementById("searchRx").focus();
            }
            this.count = 0;
        }
        this.rxNmbr = null;
        this.rxNumber = null;
    }

    closeModalAndOpenRefillDue() {
        if (this.modalRef2) {
            this.modalRef2.close();
            this.modalRef2 = null;
        }
    }
    generateAddRefillQueueWJ(rxInfo) {
        this.addRefillQueueListDisplayWJ = new wjcCore.CollectionView(
            rxInfo.map((refRxDetails, i) => {
               const  refRx =  refRxDetails["Refdetail"]["Refilldetails"][0];
                const j = {};
                j["RX#"] = refRx.Prescription.PrescNum;
                j["RowId"] = i;
                j["Rx#"] = refRx.Prescription.PrescNum;
                j["index"] = i;
                j["REF#"] = refRx.PrescReFill.ReFillNum;
                j["Ref#"] = refRx.PrescReFill.ReFillNum;
                j["Ref"] = refRx.PrescReFill.ReFillNum;
                j["Ref#"] = refRx.PrescReFill.ReFillNum;
                j["Auth#"] = refRx.Prescription.ReFillNum;
                j["Status"] = this.commonUtil.getRxStatusinSignleCharacter(refRx);
                j["Fill#"] = this._commonSvc.checkIsPartialFill(refRx.PrescReFill, refRx.Prescription) ? refRx.PrescReFill.PartialFillNo : " ";
                j["DATE FILLED"] =  (refRx && refRx.PrescReFill && refRx.PrescReFill.FillDtTm) ? moment.utc(refRx.PrescReFill.FillDtTm).local().format("MM/DD/YYYY") : null;
                j["Date Filled"] =  (refRx && refRx.PrescReFill && refRx.PrescReFill.FillDtTm) ? moment.utc(refRx.PrescReFill.FillDtTm).local().format("MM/DD/YYYY") : null;
                j["QTY"] = (refRx && refRx.PrescReFill && refRx.PrescReFill.DispQty) ? refRx.PrescReFill.DispQty.toFixed(3) :  "0.000";
                j["Qty"] = (refRx && refRx.PrescReFill && refRx.PrescReFill.DispQty) ? refRx.PrescReFill.DispQty.toFixed(3) :  "0.000";
                j["S.DAYS"] = refRx.PrescReFill.SupplyDays;
                j["S.Days"] = refRx.PrescReFill.SupplyDays;
                j["DATE ORD"] = (refRx && refRx.PrescReFill && refRx.PrescReFill.OrderDtTm) ? moment.utc(refRx.PrescReFill.OrderDtTm).local().format("MM/DD/YYYY") : null;
                j["Date Ord"] = (refRx && refRx.PrescReFill && refRx.PrescReFill.OrderDtTm) ? moment.utc(refRx.PrescReFill.OrderDtTm).local().format("MM/DD/YYYY") : null;
                j["AUTH#"] = refRx.Prescription.ReFillNum;
                j["Auth#"] = refRx.Prescription.ReFillNum;
                j["Auth Ref"] = refRx.Prescription.ReFillNum;
                const duedays = Math.round(refRx.PrescReFill.SupplyDays) -
                moment().startOf("day").diff(moment.utc(refRx.PrescReFill["FillDtTm"]).startOf("day"), "days");
                j["Due Days"] = (j["Status"] === "T" || (j["Auth#"] === 0 && j["Ref#"] === 0)) ? 0 : duedays < 0 ? 0 : duedays;
                j["DueDays"] = duedays;
                j["IsSelected"] =true;
                j["TQty Remaining"] = (refRxDetails  && refRxDetails["TotalRemainingQty"]) && (!refRx.isRxTransferred) ? (refRxDetails["TotalRemainingQty"]).toFixed(3) : "0.000";
                // j["DRUG NAME"] = (refRx && refRx.Drug) ? refRx.Drug.drugname.toUpperCase() + " " + (refRx.Drug.strength ? refRx.Drug.strength.toUpperCase() : "") +
                // (refRx.Drug.drugformname ? (refRx.Drug.drugformname.toUpperCase()) : ""): null;
                j["DRUG NAME"] = (refRx && refRx.Drug) ? this._formatsUtil.displaytallmanlettering(refRx?.Drug) : null
                // j["Drug Name"] = (refRx && refRx.Drug) ? refRx.Drug.drugname.toUpperCase() + " " + (refRx.Drug.strength ? refRx.Drug.strength.toUpperCase() : "") +
                // (refRx.Drug.drugformname ? (refRx.Drug.drugformname.toUpperCase()) : ""): null;
                j["Drug Name"] = (refRx && refRx.Drug) ? this._formatsUtil.displaytallmanlettering(refRx?.Drug) : null
                j["tallmanDrugNameExists"] = refRx.Drug?.tallmanDrugName ? true : false
                j["INSURANCE"] = refRx.insuranceInfo && refRx.insuranceInfo.insuCarrier
                j["Insurance"] = refRx.insuranceInfo && refRx.insuranceInfo.insuCarrier
                && refRx.insuranceInfo.insuCarrier.InsurerCode ? (refRx.insuranceInfo.insuCarrier.InsurerCode).toUpperCase() : "--";
                j["PATIENT NAME"] = (refRx && refRx.Patient) ? (refRx.Patient.lastname + ", " + refRx.Patient.firstname).toUpperCase() : "";
                j["Patient Name"] = (refRx && refRx.Patient) ? (refRx.Patient.lastname + ", " + refRx.Patient.firstname).toUpperCase() : "";
                j["Ref Status"] =  this._colorCode.checkRefillStatus(refRxDetails);
                j["Refill Status"] =  this._colorCode.checkRefillStatus(refRxDetails);
                j["PRESCRIBER NAME"] = (refRx && refRx.Prescriber) ?  (refRx.Prescriber.prescriberlastname + ", " + refRx.Prescriber.prescriberfirstname).toUpperCase() : " ";
                j["RxExpDate"] = refRx.RxExpirationDate ? refRx.RxExpirationDate === "0001-01-01T00:00:00" ? null : refRx.RxExpirationDate :  null ;
                j["RxExpirationDate"] = refRx.RxExpirationDate ?
                refRx.RxExpirationDate === "0001-01-01T00:00:00" ? null :
                        moment(refRx.RxExpirationDate).format("MM/DD/YYYY") : null;
                j["RxExpirationDue"] = j["RxExpirationDate"] ? moment().diff(
                    j["RxExpirationDate"],
                    "days"
                ) : null;
                j["Qty Rem Partial fill"] = (refRx.PrescReFill.PartialIndStatus === 'C') ?  "" : (refRx.islatestpartialrefill ?
                    (refRx && refRx.partialCummulativeDetails ? refRx.partialCummulativeDetails.TotRemQty : 0).toFixed(3) : " ");
                j["Qty Rem P.fill"] = (refRx.PrescReFill.IsOverFillRx) ? refRxDetails.TotalRemainingQty : j["Qty Rem Partial fill"] ;
                j["T.Rx Qty Rem"] = refRxDetails.TotalRemainingQty;
                j["Supply Days"] = j["Days Supply"] = Math.round(refRx.PrescReFill.SupplyDays);
                j["PrescNum"] = refRx.Prescription.PrescNum;
                j["Order Status"] = refRx.PrescReFill.OrderStatus ? refRx.PrescReFill.OrderStatus : null;
                j["IsDiscountinued"] = refRx.Prescription.IsDiscontinued;
                j["IsDisctFromErxType"] = refRx.Prescription.IsDisctFromErxType;
                j["PrescCount"] = this.prescCountData.find(val => +val["KeyAsString"] === refRx.Prescription.PrescNum);
                j["DrugClass"] = refRx.Drug.drugclass;
                j["RxExpDateByUser"] = refRx.rxExpiryDateByUser ? refRx.rxExpiryDateByUser :  null;
                j["IsPicked"] = refRx.pickupRx ? refRx.pickupRx.IsPickedUp === true ? true : false : false;
                j["IsPartiallyPickedup"] =refRx.pickupRx ? refRx.pickupRx.IsPartialPickup : false;
                j["rxExpiryDateByInsuranceOrControlSettings"] = refRx.rxExpiryDateByInsuranceOrControlSettings ? refRx.rxExpiryDateByInsuranceOrControlSettings === "0001-01-01T00:00:00" ? null : refRx.rxExpiryDateByInsuranceOrControlSettings :  null;
                j["Prescriber Name"] = (refRx && refRx.Prescriber) ?  (refRx.Prescriber.prescriberlastname + ", " + refRx.Prescriber.prescriberfirstname).toUpperCase() : " ";
                const OrdDate =  new Date(moment.utc(refRx.PrescReFill.OrderDtTm).format("MM/DD/YYYY"));
                const FillDate =  new Date(moment.utc(refRx.PrescReFill.FillDtTm).format("MM/DD/YYYY"));
                j["OrdFillDateDiff"] =  (FillDate.getTime() - OrdDate.getTime()) / (1000 * 3600 * 24);
                j["primaryInsurance"] = refRx.primaryInsurance ? refRx.primaryInsurance : null;
                j["RxHoverOver"] = this._colorCodeRx.showRxColorCodeAndHoverOver(refRx, "RxObject", "Rx", "hoverOver","", true);
                j["DrugHoverOver"] = this._hoverOver.getDrugNameHoverOver(j);
                return j;
            })
        );
    }
    generateControlFileWJ(rxInfo) {
        this.rxCount = rxInfo.length;
        this.refillWJ = new CollectionView(
            rxInfo.map((refRx, i) => {
                const k = {};
                k["RowId"] = i;
                k["Rx#"] = refRx.Prescription.PrescNum;
                k["Date Filled"] = moment(refRx.PrescReFill.FillDtTm).format(
                    "MM/DD/YYYY"
                );
                k["Ref"] = refRx.PrescReFill.ReFillNum;
                k["Fill#"] = this._commonSvc.checkIsPartialFill(refRx.PrescReFill, refRx.Prescription) ? refRx.PrescReFill.PartialFillNo : " ";
                k["Insurance"] =
                    refRx.insuranceInfo && refRx.insuranceInfo.insuCarrier
                        ? refRx.insuranceInfo.insuCarrier.InsurerCode ?
                            (refRx.insuranceInfo.insuCarrier.InsurerCode).toUpperCase() : " "
                        : " ";
                k["Qty"] = refRx.PrescReFill.DispQty;
                k["S.Days"] = refRx.PrescReFill.SupplyDays;
                k["Date Ord"] = moment(refRx.PrescReFill.OrderDtTm).format(
                    "MM/DD/YYYY"
                );
                k["ARef"] = refRx.Prescription.ReFillNum;
                k["Patient Name"] =
                    refRx.Patient.lastname + ", " + refRx.Patient.firstname;
                k["Ref Status"] =  this._colorCode.checkRefillStatus(refRx);
                k["Drug Name"] = refRx.Drug.drugname;
                k["Prescriber Name"] =
                    refRx.Prescriber.prescriberlastname +
                    ", " +
                    refRx.Prescriber.prescriberfirstname;
                k["PrescRefillId"] = refRx.PrescReFill.Id;
                if (this.slctdRxObj.hasOwnProperty(i)) {
                    k["IsSelected"] = true;
                } else {
                    k["IsSelected"] = false;
                }
                return k;
            })
        );
        this.actvHeaders = [
            "Rx#",
            "Date Filled",
            "Ref",
            "Fill#",
            "Insurance",
            "Qty",
            "S.Days",
            "Date Ord",
            "ARef",
            "Patient Name",
            "Ref Status",
            "Drug Name",
            "Prescriber Name"
        ];
    }

    delRow2(deleteItem: any) {
        if(deleteItem && this.rxDataCopy && this.rxDataCopy.length)  {
            this.rxDataCopy.splice(
                this.rxDataCopy.findIndex(
                    elem =>
                        deleteItem.PrescNum ===
                        elem["Refdetail"]["Refilldetails"][0].Prescription.PrescNum
                ),
                1
            );
            this.selectedRxs.splice(
                this.selectedRxs.findIndex(
                    elem =>
                        deleteItem.PrescNum ===
                        elem.PrescNum
                ),
                1
            );
        }
        this.generateAddRefillQueueWJ(this.rxDataCopy);
    }


    itemFormatter = (panel, r, c, cell) => {
        const row = panel.rows[r];
        if (row.dataItem) {
            cell.style.background = "";
            if (panel.cellType === wjcGrid.CellType.Cell && panel.columns[c].binding === "Rx#") {
                const rowId = row && row.dataItem ? row.dataItem["RowId"] : "";
                const colors = this._colorCode.showRxColorRefactoring(row.dataItem, "Rx");
                if(colors && colors.bg && colors.color) {
                    cell.style.background = colors.bg;
                    cell.style.color = colors.color;
                } else {
                    cell.style.background = "#FFF";
                    cell.style.color = "#000";
                }
                cell.style.fontWeight = "bold";
                cell.style.paddingLeft = "1rem";
            } else if (panel.cellType === wjcGrid.CellType.Cell && panel.columns[c].binding === "Drug Name") {
                const colors = this._colorCode.showDrugColorRefactoring(row.dataItem);
                if(colors && colors.bg && colors.color) {
                    cell.style.background = colors.bg;
                    cell.style.color = colors.color;
                } else {
                    cell.style.background = "#FFF";
                    cell.style.color = "#000";
                }
                cell.style.fontWeight = "bold";
                cell.style.paddingLeft = "1rem";
            } else if (panel.cellType === wjcGrid.CellType.Cell && panel.columns[c].binding === "Status") {
                const colors = this._colorCode.showRxStatusColorRefactoring(row.dataItem);
                if(colors && colors.bg && colors.color) {
                    cell.style.background = colors.bg;
                    cell.style.color = colors.color;
                } else {
                    cell.style.background = "#FFF";
                    cell.style.color = "#000";
                }
                cell.style.fontWeight = "bold";
                cell.style.paddingLeft = "1rem";
            } else if (panel.cellType === wjcGrid.CellType.Cell && panel.columns[c].binding === "Refill Status") {
                const colors = this._colorCode.colorCodingForRefillStatus(row.dataItem);
                if(colors && colors.bg && colors.color) {
                    cell.style.background = colors.bg;
                    cell.style.color = colors.color;
                   } else {
                        cell.style.background = "#FFF";
                        cell.style.color = "#000";
                    }

                cell.style.fontWeight = "bold";
                cell.style.paddingLeft = "1rem";
            } else {
                cell.style.backgroundColor = "#FFF";
                cell.style.color = "#000";
                cell.style.fontWeight = "normal";
                cell.style.textAlign = "initial";
            }
        }
    };

    closeModal() {
        this.ClosePopUp.emit(null);
        this.IsPopUpClosed.emit(null);
        if (this.modalRef) {
        this.modalRef.close();
        }
    }

    addToQueue() {
        this._rxSrvc.addToRefillQueue(this.selectedRxs)
        .pipe(takeUntil(this.unsubscribe$))
        .subscribe(resp => {
            if (this.modalRef) {
                this.modalRef.close();
                }
            if (resp !== -1) {
                if (resp > 0) {
                    this.warnDuplicate = "Selected " + resp + " Rx(s) already exists in the Refill Queue, hence " +
                    (this.rxData.length - resp) + " Rx(s) added to Queue.";
                    this._modalService.open(this.duplicateRx, {centered: true, backdrop: false, windowClass:"large--content"});
                } else {
                    this.afterAddQueue();
                }
            } else {
                this.afterAddQueue();
            }
        });
    }

    afterAddQueue() {
        this._commonSvc.getSideNavCounts(this.dateParams, true);
        this.ClosePopUp.emit(true);
    }

    routeToPatHis() {
        this._patPreDrugModalServ._patPreDrugModal$.next("patHist");
        const modalRef = this._patPreDrugModalServ.modalInstanceRef;
        modalRef.componentInstance.patientID = null;
        modalRef.componentInstance.popUpOpenFr = "RFQ";
        modalRef.componentInstance.IsPopUpClosed
        .pipe(takeUntil(this.unsubscribe$))
        .subscribe(closed => {
            modalRef.close();
            this._patPreDrugModalServ._patPreDrugModal$.next(null);
        });
        modalRef.componentInstance.emitPickedRx
        .pipe(takeUntil(this.unsubscribe$))
        .subscribe(emitPickedRx => {
            modalRef.close();
            if (emitPickedRx && emitPickedRx.length > 0) {
                if (emitPickedRx[0] && emitPickedRx[0].Patient && emitPickedRx[0].Patient.isdeceased) {
                    this.openDeceasedPopup(emitPickedRx[0]);
                } else {
                    this.count = 0;
                    this.prescNumDup = 0;
                    const disntV = emitPickedRx.map(item => item["Prescription"]["PrescNum"])
                        .filter((value, index, self) => self.indexOf(value) === index);
                    if (disntV && disntV.length) {
                        disntV.map(async v => await this.getRx(v.toString()));
                    }
                    if (this.foundRx && this.foundRx.length > 0) {
                        this.foundRx.map(curr => {
                            this.showRxNos.push(curr["Prescription"]["PrescNum"]);
                        });
                        this.modalRef1 = this._modalService.open(this.Rxexists, {
                            keyboard: false,
                            centered: true,
                            backdrop: false,
                            windowClass:"large--content"
                        });
                    }
                }
            }
            this._patPreDrugModalServ._patPreDrugModal$.next(null);
        });
    }
}
